import { useNavigate, useParams } from "react-router-dom";
import { AdminQueueItemView } from "@/features/admin/review-queue/components/AdminQueueItemView";

/** A shared-queue item, view only, before assigning it (/admin/review-queue/:itemId). */
export function ReviewQueueItemPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const navigate = useNavigate();
  const back = () => navigate("/admin/review-queue");
  // Keyed per item so nothing from one item's screen survives into the next.
  return <AdminQueueItemView key={itemId} itemId={itemId} onBack={back} onAssigned={back} />;
}
